module.exports = "/images/feature-witness-proofs-icon.svg?bf20c5289948a2c20252ab374973ec1c";